module.exports = __webpack_public_path__ + "static/img/icon_feiduodianwangyuan@2x.37c0fdaf.png";